import React from 'react';
import SLButton from 'atoms/SLButton/SLButton';
import { BiSearch } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { SUB_MODAL_CROSS } from 'ooh/Planner/common/imagePath';
import './FilterComponent.scss';
import PoiGeographyFilters from 'ooh/Planner/components/middleBar/PoiGeographyFilters';
import 'ooh/Planner/assets/css/style.css'
const data = {
  title: 'POINTS OF INTEREST',
  type: 'category,brand,poiPackage',
  includeList: [],
  excludeList: [],
  listClassName: 'fifth_filter',
  name: 'interests',
  placeHolder: 'Search brands or place categories',
};

const getPoiFilterCount = (values, interests) => {
  if (
    values.changingStatus === 'success' &&
    values.filteredValues.status &&
    values.filteredValues.id &&
    values.filteredValues.id.length
  ) {
    if (interests && interests !== '') {
      const poiFilterList = values.filteredValues.id.filter((val) =>
        val.filterName.toLowerCase().includes(interests.toLowerCase())
      );
      return poiFilterList.length;
    }
    return values.filteredValues.id.length;
  }
  return 0;
};

const FilterPopOver = ({
  _handleOnCloseFilter,
  filteredValues,
  checkedFilters,
  _handleRemove,
  _handleSectionSelectAll,
  _handleOnAudienceSubFilter,
  audienceSubFilter,
  _handleOnCheckBoxClick,
  poiPackages,
  _handleOnFilterChange,
  _handleOnInclude,
  isFilterDisabled,
  changingStatus,
  resetAllFilter,
  selectAllFilter
}) => {
  return (
    <Popover
      placement="left"
      isOpen={true}
      target={`Popover-Filter`}
      toggle={_handleOnCloseFilter}
      className="filter_popover"
    >
      <PopoverHeader className="m-2">
        <div className="filter_popover_header">
          <div className="filter_popover_header_input">
            <input
              type="text"
              className="form-control cstm_input grey_bg"
              placeholder={'Search'}
              onChange={(event) => {
                _handleOnFilterChange(event, 'interests', 'search')
              }}
              //   disabled={false}
            />
            <span className="search_icn">
              <BiSearch size={20} />
            </span>
          </div>
          <SLButton
            onClick={_handleOnCloseFilter}
            outline
            className="modal_tab_btn"
          >
            <img src={SUB_MODAL_CROSS} alt="" />
          </SLButton>
        </div>
      </PopoverHeader>
      <PopoverBody className="filter_popover_body">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <p>{`Total:${getPoiFilterCount(filteredValues, undefined)}`}</p>
          <div className="d-flex">
            <span className="select_all" onClick={selectAllFilter}>
              Select All
            </span>
            <span className="clear_all ml-3" onClick={resetAllFilter}>
              Clear
            </span>
          </div>
        </div>
        <div>
          <PoiGeographyFilters
              type={data.type}
              name={data.name}
              interests={undefined}
              filteredValues={filteredValues}
              checkedFilters={checkedFilters}
              audienceSubFilter={audienceSubFilter}
              _handleRemove={_handleRemove}
              _handleSectionSelectAll={_handleSectionSelectAll}
              _handleOnCheckBoxClick={_handleOnCheckBoxClick}
              _handleOnAudienceSubFilter={_handleOnAudienceSubFilter}
              poiPackages={poiPackages}
            />
        </div>
        <div className="modal_tab_btn">
          <button className={`include_btn`} disabled={isFilterDisabled} onClick={_handleOnInclude}>
            {changingStatus==='ongoing'?'Loading...':'Include'}
          </button>
        </div>
      </PopoverBody>
    </Popover>
  );
};
export default FilterPopOver;
